import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { revealLeft, GoldButton, OutlineButton, VIEWPORT } from "./primitives";
import { useLanguage } from "@/i18n/LanguageContext";

export const FinalCtaSection = ({ registerTo }) => {
  const { t } = useLanguage();
  return (
    <section
      data-testid="final-cta-section"
      className="relative py-14 md:py-32 border-t border-ink/5 bg-surface-muted overflow-hidden"
    >
      {/* La carte passeport est montrée une fois, dans le héros (RDEC-020). */}
      <div className="relative max-w-3xl mx-auto px-5 md:px-12">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={VIEWPORT}
          variants={revealLeft}
          className="text-center"
        >
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl tracking-tight mb-6">
            {t("finalCta.title")}
          </h2>
          <p className="text-base md:text-lg text-ink-muted leading-relaxed mb-10 max-w-xl mx-auto">
            {t("finalCta.subtitle")}
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <GoldButton to={registerTo} testId="final-register-button" track="final_cta">
              {t("finalCta.register")}
            </GoldButton>
            <OutlineButton to="/verifier" testId="final-verify-button">
              {t("finalCta.verify")}
            </OutlineButton>
          </div>

          {/* La question du prix se pose au moment du bouton, pas avant : une
              ligne ici vaut mieux qu'une section de tarifs plus haut. Aucune
              grille tant que PAYMENTS_ENABLED est faux. */}
          <p className="mt-8 text-sm text-ink-subtle leading-relaxed">
            <span data-testid="final-price-line">{t("finalCta.price")}</span>{" "}
            <Link
              to="/tarifs"
              data-testid="final-price-link"
              className="link-underline text-ink-muted hover:text-gold-ink transition-colors"
            >
              {t("finalCta.priceLink")}
            </Link>
          </p>
        </motion.div>

      </div>
    </section>
  );
};

export default FinalCtaSection;
